import React from 'react';
import { Card, CardContent } from './ui/card';
import { TruckIcon, MapPin, Clock, Package2 } from 'lucide-react';

export const Capacity = () => {
  const capacityItems = [
    {
      icon: <Package2 className="w-10 h-10 text-[#019645]" />,
      title: "Volúmenes Semanales",
      description: "Capacidad de producción flexible que se adapta a los requerimientos de nuestros clientes mayoristas. Rangos variables según temporada y contratos.",
      highlight: "Desde 100 hasta 5,000+ lbs semanales por producto"
    },
    {
      icon: <MapPin className="w-10 h-10 text-[#019645]" />,
      title: "Zonas de Entrega",
      description: "Cobertura nacional completa con logística especializada para mantener la frescura del producto.",
      highlight: "Entregas a nivel nacional en Honduras"
    },
    {
      icon: <Clock className="w-10 h-10 text-[#019645]" />,
      title: "Frecuencia de Entregas",
      description: "Programación flexible de entregas según las necesidades de cada cliente. Entregas semanales, quincenales o personalizadas.",
      highlight: "1-3 entregas por semana disponibles"
    },
    {
      icon: <TruckIcon className="w-10 h-10 text-[#019645]" />,
      title: "Tiempos de Entrega",
      description: "Entregas rápidas y puntuales para garantizar la frescura del producto en las manos de nuestros socios comerciales.",
      highlight: "24-48 horas según ubicación"
    }
  ];

  return (
    <section id="capacidad" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Capacidad y Logística
          </h2>
          <div className="w-24 h-1 bg-[#019645] mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Infraestructura y capacidad operativa diseñada para abastecer a grandes compradores
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {capacityItems.map((item, index) => (
            <Card
              key={index}
              className="border-none shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              <CardContent className="p-8">
                <div className="flex items-start mb-6">
                  <div className="p-3 bg-gray-50 rounded-lg group-hover:bg-[#019645]/10 transition-colors duration-300">
                    {item.icon}
                  </div>
                  <div className="ml-4 flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{item.title}</h3>
                    <p className="text-gray-600 leading-relaxed mb-4">{item.description}</p>
                    <div className="bg-gradient-to-r from-[#019645]/10 to-transparent p-4 rounded-lg border-l-4 border-[#019645]">
                      <p className="font-semibold text-[#077c38]">{item.highlight}</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Location Info */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-t-4 border-[#019645]">
          <div className="flex items-start mb-6">
            <MapPin className="w-8 h-8 text-[#cc1312] mr-4 flex-shrink-0 mt-1" />
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Nuestra Ubicación</h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                <strong>El Pescadero, Danlí</strong> – Km 9, carretera Danlí–El Paraíso.<br />
                Contiguo a Ciudad Nueva Pescadero, Honduras.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8 pt-8 border-t border-gray-200">
            <div className="text-center">
              <div className="text-3xl font-bold text-[#019645] mb-2">100%</div>
              <p className="text-gray-600">Cobertura Nacional</p>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#019645] mb-2">24/7</div>
              <p className="text-gray-600">Atención al Cliente</p>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#019645] mb-2">+10</div>
              <p className="text-gray-600">Años de Experiencia</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
